import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { INVOICE_REFERENCE_DATA_URL } from '../../constants';
import initialState from './invoiceInitialState';
import axios from 'axios';
import { _setSelectedMonth } from './invoiceReferenceActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getInvoiceReferenceData = createAsyncThunk(
  'stop/getInvoiceReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(INVOICE_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data;
    return data === undefined ? null : data;
  }
);

const invoiceReferenceSlice = createSlice({
  name: 'stop/invoiceReference',
  initialState,
  reducers: {
    setSelectedMonth: _setSelectedMonth,
    resetInvoiceReferenceData: () => initialState,
  },
  extraReducers: {
    [getInvoiceReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { setSelectedMonth, resetInvoiceReferenceData } =
  invoiceReferenceSlice.actions;

export default invoiceReferenceSlice.reducer;
